module.exports = __webpack_public_path__ + "img/menu-off_02.5976e6cf.png";